// extracted by mini-css-extract-plugin
export var centerText = "_dv-8";
export var container = "_dv-0";
export var doughnutContainer = "_dv-7";
export var legend = "_dv-a";
export var legendItemColorDisplay = "_dv-b";
export var legendItemLabel = "_dv-d";
export var legendItemValue = "_dv-c";
export var lg = "_dv-5";
export var maxWidth = "_dv-9";
export var md = "_dv-4";
export var responsive = "_dv-6";
export var sm = "_dv-3";
export var xs = "_dv-2";
export var xxs = "_dv-1";